import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class AgentStatusService {

  constructor(private http:HttpClient) { }
  apiUrl:String='https://xqenmxl1w9.execute-api.us-east-1.amazonaws.com/Prod';
  getStatus(agent) {
    return this.http.get<any>(this.apiUrl+'/'+agent, {observe: 'body'});
  }
}
